import OapShadeFinderCarousel from './code/Scripts/components/OapShadeFinderCarousel.vue';

export default {
  components: {
    OapShadeFinderCarousel,
  },
};
